import script from "./Complaint_Type.vue?vue&type=script&setup=true&lang=js"
export * from "./Complaint_Type.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__